<div>
  <h2>Gráfico de Ações com Variações Rápidas</h2>
  <canvas id="stockChart"></canvas>
</div>
